import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as appPropTypes from '../../components/appPropTypes';
import { withRoomContext } from '../../RoomContext';
import * as stateActions from '../../redux/stateActions';
import PeerView from '../PeerView';
import Button from '@material-ui/core/Button';

import {
    IconButton,
    MicOffIcon,
    MicIcon,
    VideoOffIcon,
    VideoIcon,
    ArticleIcon,
} from '../../components';

import { StyledIconContainer, StyledControllerContainer } from './style';

import socket from '../../socket';

import { setSelectPatientId } from '../../redux/stateActions';

const Peer = (props) => {
    const dispatch = useDispatch();

    const { id } = useParams();

    const {
        roomClient,
        peer,
        audioConsumer,
        videoConsumer,
        audioMuted,
        faceDetection,
        onSetStatsPeerId,
        type,
        isProvider,
        notCheckPermission
    } = props;

    const audioEnabled =
        Boolean(audioConsumer) && !audioConsumer.locallyPaused && !audioConsumer.remotelyPaused;

    const videoVisible =
        Boolean(videoConsumer) && !videoConsumer.locallyPaused && !videoConsumer.remotelyPaused;

    const handleTurnMicOff = () => {
        socket.emit('providerTurnPatientMicOff', {
            patientId: peer.displayName.split('|')[1],
            sessionId: id,
        });
    };
    const handleTurnCameraOff = () => {
        socket.emit('providerTurnPatientCameraOff', {
            patientId: peer.displayName.split('|')[1],
            sessionId: id,
        });
    };

    const handleSessionNote = () => {
        dispatch(setSelectPatientId(peer.displayName.split('|')[1]));
    };

    return (
        <div data-component="Peer">
            <div className="indicators">
                <If condition={!audioEnabled && type !== 'open'}>
                    <StyledIconContainer
                        style={{
                            backgroundColor: isProvider ? '#FE5D83' : 'rgba(255, 255, 255, 0.9)',
                        }}
                    >
                        <MicOffIcon width="16" height="16" fill={isProvider ? 'white' : 'gray3'} />
                    </StyledIconContainer>
                </If>
                <If condition={audioEnabled && !isProvider}>
                    <StyledIconContainer
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        }}
                    >
                        <MicIcon width="16" height="16" />
                    </StyledIconContainer>
                </If>

                <If condition={!videoConsumer && type !== 'open'}>
                    <StyledIconContainer
                        style={{
                            backgroundColor: isProvider ? '#FE5D83' : 'rgba(255, 255, 255, 0.9)',
                        }}
                    >
                        <VideoOffIcon
                            width="16"
                            height="16"
                            fill={isProvider ? 'white' : 'gray3'}
                        />
                    </StyledIconContainer>
                </If>
                <If condition={videoConsumer && !isProvider}>
                    <StyledIconContainer
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        }}
                    >
                        <VideoIcon width="16" height="16" />
                    </StyledIconContainer>
                </If>
            </div>

            <PeerView
                peer={peer}
                isProvider={isProvider}
                audioConsumerId={audioConsumer ? audioConsumer.id : null}
                videoConsumerId={videoConsumer ? videoConsumer.id : null}
                audioRtpParameters={audioConsumer ? audioConsumer.rtpParameters : null}
                videoRtpParameters={videoConsumer ? videoConsumer.rtpParameters : null}
                consumerSpatialLayers={videoConsumer ? videoConsumer.spatialLayers : null}
                consumerTemporalLayers={videoConsumer ? videoConsumer.temporalLayers : null}
                consumerCurrentSpatialLayer={
                    videoConsumer ? videoConsumer.currentSpatialLayer : null
                }
                consumerCurrentTemporalLayer={
                    videoConsumer ? videoConsumer.currentTemporalLayer : null
                }
                consumerPreferredSpatialLayer={
                    videoConsumer ? videoConsumer.preferredSpatialLayer : null
                }
                consumerPreferredTemporalLayer={
                    videoConsumer ? videoConsumer.preferredTemporalLayer : null
                }
                consumerPriority={videoConsumer ? videoConsumer.priority : null}
                audioTrack={audioConsumer ? audioConsumer.track : null}
                videoTrack={videoConsumer ? videoConsumer.track : null}
                audioMuted={audioMuted}
                videoVisible={videoVisible}
                videoMultiLayer={videoConsumer && videoConsumer.type !== 'simple'}
                audioCodec={audioConsumer ? audioConsumer.codec : null}
                videoCodec={videoConsumer ? videoConsumer.codec : null}
                audioScore={audioConsumer ? audioConsumer.score : null}
                videoScore={videoConsumer ? videoConsumer.score : null}
                faceDetection={faceDetection}
                onChangeVideoPreferredLayers={(spatialLayer, temporalLayer) => {
                    roomClient.setConsumerPreferredLayers(
                        videoConsumer.id,
                        spatialLayer,
                        temporalLayer
                    );
                }}
                onChangeVideoPriority={(priority) => {
                    roomClient.setConsumerPriority(videoConsumer.id, priority);
                }}
                onRequestKeyFrame={() => {
                    roomClient.requestConsumerKeyFrame(videoConsumer.id);
                }}
                onStatsClick={onSetStatsPeerId}
                type={type}
                notCheckPermission={notCheckPermission}
            />

            {isProvider && type !== 'open' && (
                <StyledControllerContainer>
                    <IconButton
                        style={{ width: '32px', height: '32px' }}
                        onClick={handleTurnMicOff}
                    >
                        {audioEnabled ? (
                            <MicIcon width="16" height="16" fill="white" />
                        ) : (
                            <MicOffIcon width="16" height="16" fill="white" />
                        )}
                    </IconButton>

                    <IconButton
                        style={{ width: '32px', height: '32px' }}
                        onClick={handleTurnCameraOff}
                    >
                        {videoConsumer ? (
                            <VideoIcon width="16" height="16" fill="white" />
                        ) : (
                            <VideoOffIcon width="16" height="16" fill="white" />
                        )}
                    </IconButton>
                    {type === 'group' && (
                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: '#9766E8',
                                padding: 0,
                                minWidth: 0,
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                            }}
                            onClick={handleSessionNote}
                        >
                            <ArticleIcon width="16" height="16" />
                        </Button>
                    )}
                </StyledControllerContainer>
            )}
        </div>
    );
};

Peer.propTypes = {
    roomClient: PropTypes.any.isRequired,
    peer: appPropTypes.Peer.isRequired,
    audioConsumer: appPropTypes.Consumer,
    videoConsumer: appPropTypes.Consumer,
    audioMuted: PropTypes.bool,
    faceDetection: PropTypes.bool.isRequired,
    onSetStatsPeerId: PropTypes.func.isRequired,
    type: PropTypes.string,
    isProvider: PropTypes.bool,
    notCheckPermission: PropTypes.any,
};

const mapStateToProps = (state, { id }) => {
    const me = state.me;
    const peer = state.peers[id];
    const consumersArray = peer.consumers.map((consumerId) => state.consumers[consumerId]);
    const audioConsumer = consumersArray.find((consumer) => consumer.track.kind === 'audio');
    const videoConsumer = consumersArray.find((consumer) => consumer.track.kind === 'video');

    return {
        peer,
        audioConsumer,
        videoConsumer,
        audioMuted: me.audioMuted,
        faceDetection: state.room.faceDetection,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSetStatsPeerId: (peerId) => dispatch(stateActions.setRoomStatsPeerId(peerId)),
    };
};

const PeerContainer = withRoomContext(connect(mapStateToProps, mapDispatchToProps)(Peer));

export default PeerContainer;
